import React from "react";
import clsx from "clsx";

import * as ReactUtils from "../../../../lib/util/ReactUtils";
import FocusBlocker from "../../../util/FocusBlocker/FocusBlocker";

const VisibleContext = ReactUtils.VisibleContext;

export default class MobileNavBar extends React.PureComponent {
	state = {};

	render() {
		const { logo, visible, searchBar, toggleSwitch, groupDropdown } =
			this.props;

		if (visible) {
			this.shown = true;
		}

		if (!this.shown) return null;

		return (
			<FocusBlocker
				active={!visible}
				className={clsx("Navigation__mobile-bar", visible && "--mobile")}
			>
				<VisibleContext.Provider value={visible}>
					{toggleSwitch}
					{logo}
					<div className={"Navigation__mobile-controls"}>
						<div className={"Navigation__groups"}>{groupDropdown}</div>
						{searchBar}
					</div>
				</VisibleContext.Provider>
			</FocusBlocker>
		);
	}
}
